var rr = Object.defineProperty;
var or = (e, t, n) => t in e ? rr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ht = (e, t, n) => (or(e, typeof t != "symbol" ? t + "" : t, n), n);
import { jsx as d, jsxs as W, Fragment as Wt } from "react/jsx-runtime";
import ir, { Fragment as Le, useRef as $e, useState as Ue, useEffect as Ht, forwardRef as sr } from "react";
import { reduce as et, trim as N, get as h, camelCase as z, isPlainObject as ar, isString as Et, has as lr, isEmpty as Xe, isNumber as Xt, isFinite as kt, isNil as Er, omit as cr, isArray as dr, find as Tr, cloneDeep as Rr } from "lodash";
import Ve from "twig";
import { v4 as Ir } from "uuid";
import D, { createGlobalStyle as ur, css as Lr, StyleSheetManager as _r } from "styled-components";
import { XmlNode as Yt, parseXml as Ar } from "@rgrove/parse-xml";
import { animated as Ke, useSpring as ct, useIsomorphicLayoutEffect as Nr } from "@react-spring/web";
import Vt from "react-dotdotdot";
import Or from "linkify-it";
import Dr from "tlds";
import Sr from "react-shadow";
function fr(e) {
}
function Cr() {
  Ve.extend(fr);
}
const pt = {};
function hr() {
  for (const e in pt)
    Ve.extendFilter(e, pt[e]);
}
const $t = {};
function pr() {
  for (const e in $t)
    Ve.extendFunction(e, $t[e]);
}
function Kt(e, t, n) {
  const r = Ve.twig({
    id: n,
    data: e,
    // @ts-expect-error The published types do not match the actual parameters
    autoescape: !0,
    strict_variables: t,
    rethrow: !0
  });
  return $r(r.tokens), r;
}
function $r(e) {
  e != null && e.length;
}
const gt = Ir();
function gr(e, t) {
  const n = `{% if (${e}) %}${gt}{% endif %}`;
  return (Kt(n, !0).render(t) || "").trim() === gt;
}
function mr(e, t) {
  return Kt(e, !1).render(t);
}
Cr();
hr();
pr();
function yr() {
  return {
    evaluateCondition: gr,
    interpolateString: mr
  };
}
const g = D.div`
  box-sizing: border-box;
  & * {
    box-sizing: border-box;
  }
`;
var H = /* @__PURE__ */ ((e) => (e.ALIGNMENT = "alignment", e.BACKGROUND = "background", e.BORDER_RADIUS = "borderRadius", e.BORDER_COLOR = "borderColor", e.BORDER_WIDTH = "borderWidth", e.PADDING = "padding", e))(H || {}), A = /* @__PURE__ */ ((e) => (e.BLOCK = "Block", e.CARD = "Card", e.DIVIDER = "Divider", e.DRAWER = "Drawer", e.DRAWER_FIXED_PART = "Fixed", e.DRAWER_EXPANDABLE_PART = "Expandable", e.IMAGE = "Image", e.LINK = "Link", e.LIST = "List", e.SECTION = "Section", e.STRING_VALUE = "StringValue", e.TEXT = "Text", e))(A || {}), X = /* @__PURE__ */ ((e) => (e.NONE = "none", e.X_SMALL = "extraSmall", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.X_LARGE = "extraLarge", e))(X || {}), R = /* @__PURE__ */ ((e) => (e.GREY_100 = "grey100", e.GREY_300 = "grey300", e.GREY_500 = "grey500", e.GREY_800 = "grey800", e.GREY_900 = "grey900", e.BLUEGREY_100 = "blueGrey100", e.BLUEGREY_300 = "blueGrey300", e.BLUEGREY_500 = "blueGrey500", e.BLUEGREY_800 = "blueGrey800", e.GREEN_100 = "green100", e.GREEN_400 = "green400", e.GREEN_700 = "green700", e.PURPLE_100 = "purple100", e.PURPLE_400 = "purple400", e.PURPLE_700 = "purple700", e.YELLOW_100 = "yellow100", e.YELLOW_400 = "yellow400", e.YELLOW_700 = "yellow700", e.RED_100 = "red100", e.RED_400 = "red400", e.RED_700 = "red700", e.BLACK = "black", e.WHITE = "white", e.GREY = "grey", e.GREEN = "green", e.RED = "red", e.PURPLE = "purple", e.YELLOW = "yellow", e.TRANSPARENT = "transparent", e.INHERIT = "inherit", e))(R || {}), x = /* @__PURE__ */ ((e) => (e.DEFAULT_TEXT = "text", e.SUBTLE = "subtle", e.PRIMARY = "primary", e.INFO = "info", e.WARNING = "warning", e.ERROR = "error", e))(x || {}), B = /* @__PURE__ */ ((e) => (e.NONE = "none", e.X_SMALL = "extraSmall", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.X_LARGE = "extraLarge", e))(B || {}), k = /* @__PURE__ */ ((e) => (e.NONE = "none", e.THIN = "thin", e.MEDIUM = "medium", e.THICK = "thick", e.X_THICK = "extraThick", e))(k || {}), J = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.DEFAULT = "default", e.MEDIUM = "medium", e.LARGE = "large", e.X_LARGE = "extraLarge", e))(J || {}), Q = /* @__PURE__ */ ((e) => (e.LIGHT = "light", e.REGULAR = "regular", e.MEDIUM = "medium", e.SEMI_BOLD = "semiBold", e.BOLD = "bold", e))(Q || {}), Z = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e.CENTER = "center", e))(Z || {}), Ee = /* @__PURE__ */ ((e) => (e.NONE = "none", e.NORMAL = "normal", e.UNDERLINED = "underlined", e))(Ee || {}), Ie = /* @__PURE__ */ ((e) => (e.AUTO = "auto", e.LTR = "ltr", e.RTL = "rtl", e))(Ie || {}), ke = /* @__PURE__ */ ((e) => (e.NORMAL = "normal", e.BREAK_WORDS = "breakWords", e))(ke || {}), te = /* @__PURE__ */ ((e) => (e.AUTO = "auto", e.X_SMALL = "extraSmall", e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.X_LARGE = "extraLarge", e))(te || {}), Ge = /* @__PURE__ */ ((e) => (e.ROUND = "circle", e.RECT = "rectangle", e))(Ge || {}), Me = /* @__PURE__ */ ((e) => (e.FILL = "fill", e.FIT = "fit", e))(Me || {});
const br = 10, mt = 25;
var j = /* @__PURE__ */ ((e) => (e.ROW = "row", e.STACKED = "stacked", e))(j || {}), ue = /* @__PURE__ */ ((e) => (e.COLLAPSED = "collapsed", e.EXPANDED = "expanded", e.EXPAND_FIRST = "expandFirst", e))(ue || {}), P = /* @__PURE__ */ ((e) => (e.NONE = "none", e.SECTION_STYLES = "styles", e.SECTION_DEFAULTS = "defaults", e.SECTION_GLOBAL_STYLES = "globalStyles", e.STYLE_ALIGNMENT = "alignment", e.STYLE_BORDER_RADIUS = "borderRadius", e.STYLE_COLOR = "colorAliases", e.STYLE_FONT_SIZE = "fontSize", e.STYLE_FONT_WEIGHT = "fontWeight", e.STYLE_SPACING = "spacing", e.STYLE_SIZE = "size", e.STYLE_STROKE_WIDTH = "strokeWidth", e.STYLE_TEXT_WRAPPING = "wrap", e))(P || {}), E = /* @__PURE__ */ ((e) => (e.ALIGNMENT = "align", e.BORDER_RADIUS = "border radius", e.COLOR = "color", e.FONT_SIZE = "font size", e.FONT_WEIGHT = "font weight", e.IMAGE_SIZE = "image size", e.SPACING = "spacing", e.STROKE_WIDTH = "stroke width", e.TEXT_DECORATION = "decoration", e.TEXT_WRAPPING = "wrapping", e))(E || {});
class V {
  constructor(t) {
    ht(this, "_map");
    this._map = { ...t };
  }
  overrideStyles(t) {
    this._map = { ...this._map, ...t };
  }
  get styles() {
    return { ...this._map };
  }
  get styleAttributeNames() {
    return Object.keys(this._map);
  }
  get styleValues() {
    return et(
      this._map,
      (t, n, r) => (t[r] = n.style, t),
      {}
    );
  }
  get styleTypes() {
    return et(
      this._map,
      (t, n, r) => (t[r] = n.styleType, t),
      {}
    );
  }
}
const tt = new V({
  [H.ALIGNMENT]: { style: Z.LEFT, styleType: E.ALIGNMENT },
  [H.BACKGROUND]: { style: R.TRANSPARENT, styleType: E.COLOR },
  [H.BORDER_RADIUS]: { style: X.NONE, styleType: E.BORDER_RADIUS },
  [H.BORDER_COLOR]: { style: R.TRANSPARENT, styleType: E.COLOR },
  [H.BORDER_WIDTH]: { style: k.NONE, styleType: E.STROKE_WIDTH },
  [H.PADDING]: { style: B.MEDIUM, styleType: E.SPACING }
});
var i = /* @__PURE__ */ ((e) => (e.ARIA_DESCRIPTION = "aria", e.CLASS_NAME = "className", e.CONDITIONAL_RENDERING_EXPRESSION = "when", e.DATA_SOURCE = "dataSource", e.ELEMENT_ID = "id", e.TEST_ID = "testId", e.TEXT_DIRECTION = "direction", e))(i || {}), zt = /* @__PURE__ */ ((e) => (e.SEPARATE_LIST_ITEMS = "separateItems", e))(zt || {});
function Oe(e, t, n = !1) {
  const r = N(h(e, t)).toLowerCase();
  if (!r)
    return n;
  switch (r) {
    case "yes":
    case "true":
      return !0;
    case "no":
    case "false":
      return !1;
    default:
      throw Error(
        `Unexpected attribute value for "${t}". Expected "yes"/"no" or "true"/"false", got "${r}" instead`
      );
  }
}
function f(e, t, n = "") {
  return N(h(e, t, n));
}
function F(e, t) {
  return t.reduce(
    (n, r) => (n[r] = f(e, String(r)), n),
    {}
  );
}
function Zt(e, t, n = 0) {
  const r = N(h(e, t) || String(n)), o = parseInt(r, 10);
  if (o !== o)
    throw Error(`Unexpected "${t}" value. Expected a numeric string, got "${r}" instead`);
  return o;
}
function De(e, t, n, r) {
  const o = h(e, t) || r, s = z(o);
  if (n.includes(s))
    return s;
  throw Error(
    `Unexpected attribute value for "${t}". Expected one of ${JSON.stringify(n)}, got "${o}" instead`
  );
}
function jt(e, t) {
  return De(
    e,
    t,
    [Z.LEFT, Z.RIGHT, Z.CENTER],
    Z.LEFT
  );
}
function ze(e, t) {
  return De(
    e,
    t,
    [Ie.AUTO, Ie.RTL, Ie.LTR],
    Ie.AUTO
  );
}
function vr(e, t, n) {
  for (const r of t)
    if (!N(h(e, r)))
      throw Error(`<${n}> is missing a required parameter "${r}"`);
}
function oe(e, t, n) {
  return e.reduce((r, o) => (r[o] = f(t, o, n[o]), r), {});
}
function ce(e, t = [], n = !0) {
  return et(
    e,
    (r, o, s) => {
      if (t.includes(s))
        r[s] = o;
      else {
        const a = z(o);
        (a || !n) && (r[s] = a);
      }
      return r;
    },
    {}
  );
}
function dt(e) {
  return ar(e);
}
function qt(e) {
  return Et(e);
}
function q(e) {
  const t = {};
  for (const n in e) {
    const r = e[n];
    if (qt(r)) {
      const o = N(r);
      o && (t[n] = o);
    } else
      r && (t[n] = r);
  }
  return t;
}
function yt() {
  let e = () => {
  }, t = () => {
  };
  return {
    promise: new Promise((r, o) => {
      e = r, t = o;
    }),
    resolve: e,
    reject: t
  };
}
var U = /* @__PURE__ */ ((e) => (e.DATA_VALUE = "data", e.ITERATOR = "iterator", e.CONTAINER = "container", e.DECORATIVE_NODE = "decoration", e))(U || {});
function xe(e) {
  return e.type === Yt.TYPE_ELEMENT;
}
function Tt(e) {
  return e.type === Yt.TYPE_TEXT;
}
function Jt(e) {
  return Tt(e) && !N(e.text);
}
function Pe(e, t) {
  if (e != null && e.length)
    return e.find((n) => xe(n) && n.name === t);
}
function de({
  parentNodeName: e,
  nodes: t,
  dataContext: n,
  getNodeDescriptor: r,
  expressionEvaluator: o
}) {
  return t != null && t.length ? !!t.find((s) => {
    var c;
    if (!xe(s))
      return !1;
    const a = r(s.name), l = a.canRender({
      attributes: s.attributes,
      children: s.children,
      parentNodeName: e,
      dataContext: n,
      getNodeDescriptor: r,
      expressionEvaluator: o
    });
    return a.nodeType === U.DATA_VALUE || a.nodeType === U.ITERATOR ? l : a.nodeType === U.CONTAINER && ((c = s.children) != null && c.length) ? l && de({
      parentNodeName: s.name,
      nodes: s.children,
      dataContext: n,
      getNodeDescriptor: r,
      expressionEvaluator: o
    }) : !1;
  }) : !1;
}
function ge({
  parentNodeName: e,
  nodes: t,
  dataContext: n,
  hostAppConfig: r,
  getNodeDescriptor: o,
  expressionEvaluator: s
}) {
  return t != null && t.length ? t.reduce((a, l, c) => {
    if (!xe(l)) {
      if (Jt(l))
        return a;
      throw Error("Unexpected child. All plain text must be wrapped in <Text></Text>");
    }
    const I = o(l.name);
    if (!I.canRender({
      attributes: l.attributes,
      children: l.children,
      parentNodeName: e,
      dataContext: n,
      getNodeDescriptor: o,
      expressionEvaluator: s
    }))
      return a;
    const T = I.render({
      attributes: l.attributes,
      children: l.children,
      parentNodeName: e,
      dataContext: n,
      hostAppConfig: r,
      getNodeDescriptor: o,
      expressionEvaluator: s
    });
    return a.push(/* @__PURE__ */ d(Le, { children: T }, c)), a;
  }, []) : [];
}
const Gr = {
  [R.GREY_100]: "#F6F6F6",
  [R.GREY_300]: "#E3E3E3",
  [R.GREY_500]: "#B3B3B3",
  [R.GREY_800]: "#484848",
  [R.GREY_900]: "#212121",
  [R.BLUEGREY_100]: "#CFD8DC",
  [R.BLUEGREY_300]: "#90A4AE",
  [R.BLUEGREY_500]: "#607D8B",
  [R.BLUEGREY_800]: "#37474F",
  [R.GREEN_100]: "#D8F4D8",
  [R.GREEN_400]: "#009B00",
  [R.GREEN_700]: "#003C00",
  [R.PURPLE_100]: "#E6DCFF",
  [R.PURPLE_400]: "#8C69F0",
  [R.PURPLE_700]: "#331962",
  [R.YELLOW_100]: "#FFF2C6",
  [R.YELLOW_400]: "#FFBE00",
  [R.YELLOW_700]: "#8E660C",
  [R.RED_100]: "#FFCDD2",
  [R.RED_400]: "#D50E0E",
  [R.RED_700]: "#5C0000",
  [R.BLACK]: "#000000",
  [R.WHITE]: "#FFFFFF",
  [R.GREEN]: "#009B00",
  [R.GREY]: "#B3B3B3",
  [R.PURPLE]: "#8C69F0",
  [R.RED]: "#D50E0E",
  [R.YELLOW]: "#FFBE00",
  [R.TRANSPARENT]: "transparent",
  [R.INHERIT]: "inherit"
}, Mr = {
  [x.DEFAULT_TEXT]: R.GREY_900,
  [x.ERROR]: R.RED_400,
  [x.INFO]: R.PURPLE_400,
  [x.PRIMARY]: R.GREEN_400,
  [x.SUBTLE]: R.GREY_500,
  [x.WARNING]: R.YELLOW_400
};
function Rt(e) {
  if (!e)
    throw Error("Missing color value");
  const t = z(e), n = h(Mr, t, t), r = h(Gr, n);
  if (!r)
    throw Error(`Unexpected color "${e}"`);
  return r;
}
function Ye(e, t = []) {
  const n = N(e).toLowerCase();
  return /^([1-9]\d*)(px|em|rem|pt)$/gi.test(n) || t.includes(n);
}
function me(e) {
  const [t, n] = N(e).split("/").map((r) => N(r).toLowerCase());
  return [t || "16px", n || "normal"];
}
function Pr(e) {
  const t = N(e).split("/").map((o) => N(o).toLowerCase()), [n, r] = t;
  if (!Ye(n, ["auto"]) || r && !Ye(r, ["auto"]) || t.length > 2)
    throw Error(`Invalid image size "${e}"`);
  return [n, r || "auto"];
}
const Ur = {
  [te.AUTO]: "auto",
  [te.X_SMALL]: "16px/16px",
  [te.SMALL]: "24px/24px",
  [te.MEDIUM]: "32px/32px",
  [te.LARGE]: "84px/84px",
  [te.X_LARGE]: "124px/124px"
};
function xr(e) {
  const t = z(e);
  if (!t)
    throw Error("Missing or invalid size");
  const n = h(Ur, t);
  if (!n) {
    const r = N(e).toLowerCase();
    if (Br(r))
      return r;
    throw Error(`Invalid size value "${e}"`);
  }
  return n;
}
function Br(e) {
  const t = e.split("/").map((r) => N(r));
  return t.length !== 2 ? !1 : t.find((r) => !Ye(r)) === void 0;
}
const bt = {
  [X.NONE]: "0",
  [X.X_SMALL]: "2px",
  [X.SMALL]: "4px",
  [X.MEDIUM]: "8px",
  [X.LARGE]: "16px",
  [X.X_LARGE]: "20px"
}, vt = {
  [B.NONE]: "0",
  [B.X_SMALL]: "2px",
  [B.SMALL]: "4px",
  [B.MEDIUM]: "8px",
  [B.LARGE]: "16px",
  [B.X_LARGE]: "24px"
}, Gt = {
  [k.NONE]: "0",
  [k.THIN]: "1px",
  [k.MEDIUM]: "2px",
  [k.THICK]: "3px",
  [k.X_THICK]: "4px"
};
function wr(e) {
  const t = z(e);
  if (!t)
    return vt[B.NONE];
  const n = h(vt, t);
  if (!n)
    throw Error(`Unexpected spacing value "${e}"`);
  return n;
}
function Fr(e) {
  const t = z(e);
  if (!t)
    return bt[X.NONE];
  const n = h(bt, t);
  if (!n)
    throw Error(`Unexpected radius value "${e}"`);
  return n;
}
function Wr(e) {
  const t = z(e);
  if (!t)
    return Gt[k.NONE];
  const n = h(Gt, t);
  if (!n) {
    const r = N(e).toLowerCase();
    if (Ye(r, ["0", "0px"]))
      return r;
    throw Error(`Invalid width "${e}"`);
  }
  return n;
}
const Hr = {
  [Z.CENTER]: "center",
  [Z.LEFT]: "left",
  [Z.RIGHT]: "right"
}, Xr = {
  [ke.NORMAL]: "normal",
  [ke.BREAK_WORDS]: "break-word"
}, kr = {
  [Ee.NONE]: "none",
  [Ee.NORMAL]: "initial",
  [Ee.UNDERLINED]: "underline"
};
function Yr(e) {
  const t = h(Hr, z(e));
  if (!t)
    throw Error(`Unexpected alignment "${e}"`);
  return t;
}
function Vr(e) {
  const t = h(kr, z(e));
  if (!t)
    throw Error(`Unexpected text decoration "${e}"`);
  return t;
}
function Kr(e) {
  const t = h(Xr, z(e));
  if (!t)
    throw Error(`Unexpected wrapping mode "${e}"`);
  return t;
}
const zr = {
  [J.SMALL]: "10px/16px",
  [J.DEFAULT]: "13px/20px",
  [J.MEDIUM]: "16px/24px",
  [J.LARGE]: "20px/28px",
  [J.X_LARGE]: "24px/32px"
}, Zr = {
  [Q.LIGHT]: "300",
  [Q.REGULAR]: "400",
  [Q.MEDIUM]: "500",
  [Q.SEMI_BOLD]: "600",
  [Q.BOLD]: "700"
};
function jr(e) {
  const t = h(zr, z(e));
  if (!t)
    throw Error(`Unexpected font size "${e}"`);
  return t;
}
function qr(e) {
  const t = h(Zr, z(e));
  if (!t)
    throw Error(`Unexpected font weight "${e}"`);
  return t;
}
function Jr(e, t, n) {
  const o = {
    [E.ALIGNMENT]: P.STYLE_ALIGNMENT,
    [E.BORDER_RADIUS]: P.STYLE_BORDER_RADIUS,
    [E.COLOR]: P.STYLE_COLOR,
    [E.FONT_SIZE]: P.STYLE_FONT_SIZE,
    [E.FONT_WEIGHT]: P.STYLE_FONT_WEIGHT,
    [E.IMAGE_SIZE]: P.STYLE_SIZE,
    [E.SPACING]: P.STYLE_SPACING,
    [E.STROKE_WIDTH]: P.STYLE_STROKE_WIDTH,
    [E.TEXT_DECORATION]: P.NONE,
    [E.TEXT_WRAPPING]: P.STYLE_TEXT_WRAPPING
  }[t];
  if (o !== P.NONE)
    return h(n, [P.SECTION_STYLES, o, e]);
}
function Qr(e, t) {
  return {
    [E.ALIGNMENT]: Yr,
    [E.BORDER_RADIUS]: Fr,
    [E.COLOR]: Rt,
    [E.FONT_SIZE]: jr,
    [E.FONT_WEIGHT]: qr,
    [E.SPACING]: wr,
    [E.IMAGE_SIZE]: xr,
    [E.STROKE_WIDTH]: Wr,
    [E.TEXT_DECORATION]: Vr,
    [E.TEXT_WRAPPING]: Kr
  }[t](e);
}
function ie(e, t, n) {
  const r = z(e);
  if (!lr(n, [P.SECTION_DEFAULTS, r]))
    return t;
  const o = h(n, [P.SECTION_DEFAULTS, r], {}), s = { ...t };
  for (const a in o)
    s[a] === void 0 && (s[a] = o[a]);
  return s;
}
function se(e, t, n) {
  const r = {};
  for (const o in t) {
    const s = e[o];
    if (s === void 0)
      continue;
    const a = Jr(s, t[o], n);
    r[o] = a || Qr(s, t[o]);
  }
  return r;
}
function C(e, t) {
  if (!t)
    return e || void 0;
  if (e)
    return [e, t].join("_");
}
const Qt = [
  i.ARIA_DESCRIPTION,
  i.CLASS_NAME,
  i.ELEMENT_ID,
  i.TEXT_DIRECTION,
  i.TEST_ID,
  i.CONDITIONAL_RENDERING_EXPRESSION
], en = tt.styleAttributeNames, eo = [...Qt, ...en];
function tn(e) {
  const { attributes: t, children: n, dataContext: r, expressionEvaluator: o, getNodeDescriptor: s } = e, a = f(t, i.CONDITIONAL_RENDERING_EXPRESSION);
  return (a ? o.evaluateCondition(a, r) : !0) ? de({
    parentNodeName: A.BLOCK,
    nodes: n,
    dataContext: r,
    getNodeDescriptor: s,
    expressionEvaluator: o
  }) : !1;
}
function to(e) {
  const { attributes: t, children: n, dataContext: r, hostAppConfig: o, getNodeDescriptor: s, expressionEvaluator: a } = e;
  if (!tn(e))
    return null;
  const l = ce(t, Qt), c = ie(A.BLOCK, l, o), I = oe(eo, c, tt.styleValues), u = se(I, tt.styleTypes, o), T = { ...I, ...u }, O = ge({
    parentNodeName: A.BLOCK,
    nodes: n,
    dataContext: r,
    hostAppConfig: o,
    getNodeDescriptor: s,
    expressionEvaluator: a
  });
  if (!O.length)
    return null;
  const L = no(T), S = L[i.ARIA_DESCRIPTION], y = L[i.TEST_ID], p = q({ "aria-description": S }), m = C(y);
  return /* @__PURE__ */ d(
    ro,
    {
      ...p,
      id: L[i.ELEMENT_ID],
      "data-testid": m,
      dir: L[i.TEXT_DIRECTION] || "auto",
      className: L[i.CLASS_NAME],
      $alignment: L[H.ALIGNMENT],
      $background: L[H.BACKGROUND],
      $borderColor: L[H.BORDER_COLOR],
      $borderRadius: L[H.BORDER_RADIUS],
      $borderWidth: L[H.BORDER_WIDTH],
      $padding: L[H.PADDING],
      children: O
    }
  );
}
function no(e) {
  const t = F(e, en);
  return {
    [i.ARIA_DESCRIPTION]: f(e, i.ARIA_DESCRIPTION),
    [i.CLASS_NAME]: f(e, i.CLASS_NAME),
    [i.TEXT_DIRECTION]: ze(e, i.TEXT_DIRECTION),
    [i.ELEMENT_ID]: f(e, i.ELEMENT_ID),
    [i.TEST_ID]: f(e, i.TEST_ID),
    ...t,
    [H.ALIGNMENT]: jt(e, H.ALIGNMENT)
  };
}
const ro = D(g)`
  background: ${(e) => e.$background};
  border: ${(e) => `${e.$borderWidth} solid ${e.$borderColor}`};
  border-radius: ${(e) => e.$borderRadius};
  padding: ${(e) => e.$padding};
  text-align: ${(e) => e.$alignment};
`;
var he = /* @__PURE__ */ ((e) => (e.TITLE = "title", e))(he || {}), pe = /* @__PURE__ */ ((e) => (e.HOST_DEFAULT_STYLES = "defaultStyles", e.EMIT_GLOBAL_STYLES = "emitGlobalStyles", e.TITLE_LINE_HEIGHT = "titleLineHeight", e))(pe || {}), v = /* @__PURE__ */ ((e) => (e.BACKGROUND_COLOR = "background", e.BORDER_COLOR = "borderColor", e.BORDER_RADIUS = "borderRadius", e.BORDER_WIDTH = "borderWidth", e.PADDING = "padding", e.TITLE_COLOR = "titleColor", e.TITLE_FONT_SIZE = "titleFontSize", e.TITLE_FONT_WEIGHT = "titleFontWeight", e))(v || {});
function oo(e) {
  const { children: t, emitGlobalStyles: n, ...r } = e, o = r[pe.HOST_DEFAULT_STYLES] || {}, s = n ? {} : o, a = e[i.ARIA_DESCRIPTION], l = e[i.TEST_ID], c = q({ "aria-description": a }), I = C(l), u = C(l, "title"), T = n && !Xe(o) ? ur(() => ({ ...o })) : ir.Fragment, O = N(e[he.TITLE]), L = O ? /* @__PURE__ */ d(
    so,
    {
      "data-testid": u,
      $color: r[v.TITLE_COLOR],
      $fontSize: r[v.TITLE_FONT_SIZE],
      $fontWeight: r[v.TITLE_FONT_WEIGHT],
      $lineHeight: r[pe.TITLE_LINE_HEIGHT],
      children: O
    }
  ) : null;
  return /* @__PURE__ */ W(Wt, { children: [
    /* @__PURE__ */ d(T, {}),
    /* @__PURE__ */ W(
      io,
      {
        ...c,
        id: e[i.ELEMENT_ID],
        className: e[i.CLASS_NAME],
        "data-testid": I,
        $globalStyles: s,
        $background: r[v.BACKGROUND_COLOR],
        $borderColor: r[v.BORDER_COLOR],
        $borderRadius: r[v.BORDER_RADIUS],
        $borderWidth: r[v.BORDER_WIDTH],
        $padding: r[v.PADDING],
        children: [
          L,
          /* @__PURE__ */ d("div", { children: t })
        ]
      }
    )
  ] });
}
const io = D.div((e) => ({
  ...e.$globalStyles,
  background: e.$background || "transparent",
  borderColor: e.$borderColor || "transparent",
  borderRadius: e.$borderRadius || 0,
  borderStyle: e.$borderWidth && e.$borderWidth !== "none" ? "solid" : "none",
  borderWidth: e.$borderWidth || "none",
  boxShadow: "0 2px 8px 0 rgba(0,0,0,0.08)",
  marginBottom: 8,
  padding: e.$padding || 0
})), so = D.div`
  display: block;
  color: ${(e) => e.$color};
  font-size: ${(e) => e.$fontSize};
  font-weight: ${(e) => e.$fontWeight || 600};
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  line-height: ${(e) => e.$lineHeight || "normal"};
  margin-bottom: 8px;
  white-space: nowrap;
`, We = new V({
  [v.BACKGROUND_COLOR]: { style: R.WHITE, styleType: E.COLOR },
  [v.BORDER_COLOR]: { style: R.GREY_300, styleType: E.COLOR },
  [v.BORDER_WIDTH]: { style: k.THIN, styleType: E.STROKE_WIDTH },
  [v.BORDER_RADIUS]: { style: X.MEDIUM, styleType: E.BORDER_RADIUS },
  [v.PADDING]: { style: B.LARGE, styleType: E.SPACING },
  [v.TITLE_COLOR]: { style: x.DEFAULT_TEXT, styleType: E.COLOR },
  [v.TITLE_FONT_SIZE]: { style: J.MEDIUM, styleType: E.FONT_SIZE },
  [v.TITLE_FONT_WEIGHT]: { style: Q.BOLD, styleType: E.FONT_WEIGHT }
}), ao = [
  i.ARIA_DESCRIPTION,
  i.CLASS_NAME,
  i.ELEMENT_ID,
  i.TEST_ID
], nn = [...ao, he.TITLE];
function rn(e) {
  const { parentNodeName: t, children: n, dataContext: r, expressionEvaluator: o, getNodeDescriptor: s } = e;
  if (t)
    throw Error(`<${A.CARD}> cannot be a child of any other component`);
  return de({
    parentNodeName: A.CARD,
    nodes: n,
    dataContext: r,
    expressionEvaluator: o,
    getNodeDescriptor: s
  });
}
function lo(e) {
  const { attributes: t, children: n, dataContext: r, hostAppConfig: o, expressionEvaluator: s, getNodeDescriptor: a, options: l } = e;
  if (!rn(e))
    return null;
  const c = ge({
    parentNodeName: A.CARD,
    nodes: n,
    dataContext: r,
    hostAppConfig: o,
    expressionEvaluator: s,
    getNodeDescriptor: a
  });
  if (l != null && l.useParentCardContainer)
    return /* @__PURE__ */ d(Wt, { children: c });
  const I = [...nn, ...We.styleAttributeNames], u = ie(A.CARD, t, o), T = oe(I, u, We.styleValues), O = se(T, We.styleTypes, o), L = { ...T, ...O }, S = Eo(L, o, !!(l != null && l.useShadowDOM));
  return S[he.TITLE] && (S[he.TITLE] = s.interpolateString(S[he.TITLE], r)), /* @__PURE__ */ d(oo, { ...S, children: c });
}
function Eo(e, t, n) {
  const r = F(e, nn), o = F(e, We.styleAttributeNames), s = h(t, P.SECTION_GLOBAL_STYLES) || {}, [a, l] = me(
    o[v.TITLE_FONT_SIZE]
  );
  return {
    ...r,
    ...o,
    [v.TITLE_FONT_SIZE]: a,
    [pe.TITLE_LINE_HEIGHT]: l,
    [pe.HOST_DEFAULT_STYLES]: co(s),
    [pe.EMIT_GLOBAL_STYLES]: n
  };
}
function co(e) {
  return !dt(e) || Xe(e) ? {} : Object.keys(e).includes("*") ? e : { "*": { ...e } };
}
var _e = /* @__PURE__ */ ((e) => (e.LINE_COLOR = "color", e.LINE_WIDTH = "thickness", e.SPACING = "spacing", e))(_e || {});
const nt = new V({
  [_e.LINE_COLOR]: { style: R.GREY_300, styleType: E.COLOR },
  [_e.LINE_WIDTH]: { style: k.THIN, styleType: E.STROKE_WIDTH },
  [_e.SPACING]: { style: B.SMALL, styleType: E.SPACING }
}), on = [
  i.ARIA_DESCRIPTION,
  i.CLASS_NAME,
  i.ELEMENT_ID,
  i.TEST_ID,
  i.CONDITIONAL_RENDERING_EXPRESSION
], sn = nt.styleAttributeNames, To = [...on, ...sn];
function an(e) {
  const { attributes: t, dataContext: n, expressionEvaluator: r } = e, o = f(t, i.CONDITIONAL_RENDERING_EXPRESSION);
  return o ? r.evaluateCondition(o, n) : !0;
}
function Ro(e) {
  const { attributes: t, hostAppConfig: n } = e;
  if (!an(e))
    return null;
  const r = ce(t, on), o = ie(A.DIVIDER, r, n), s = oe(
    To,
    o,
    nt.styleValues
  ), a = se(s, nt.styleTypes, n), l = { ...s, ...a }, c = Io(l), I = c[i.ARIA_DESCRIPTION], u = c[i.TEST_ID], T = q({ "aria-description": I }), O = C(u), L = C(u, "divider-line");
  return /* @__PURE__ */ d(
    uo,
    {
      ...T,
      id: c[i.ELEMENT_ID],
      className: c[i.CLASS_NAME],
      "data-testid": O,
      $padding: c[_e.SPACING],
      children: /* @__PURE__ */ d(
        Lo,
        {
          "data-testid": L,
          $lineColor: c[_e.LINE_COLOR],
          $lineWidth: c[_e.LINE_WIDTH]
        }
      )
    }
  );
}
function Io(e) {
  const t = F(e, [
    i.ARIA_DESCRIPTION,
    i.CLASS_NAME,
    i.ELEMENT_ID,
    i.TEST_ID
  ]), n = F(e, sn);
  return {
    ...t,
    ...n
  };
}
const uo = D(g)`
  display: block;
  padding: ${(e) => e.$padding} 0;
`, Lo = D(g)`
  background-color: ${(e) => e.$lineColor};
  height: ${(e) => e.$lineWidth};
`;
function ln(e) {
  const { attributes: t, children: n, dataContext: r, expressionEvaluator: o, getNodeDescriptor: s } = e;
  Ao(n);
  const a = f(t, i.CONDITIONAL_RENDERING_EXPRESSION);
  if (a ? o.evaluateCondition(a, r) : !0) {
    const c = Pe(n, A.DRAWER_FIXED_PART);
    return En({
      children: c == null ? void 0 : c.children,
      dataContext: r,
      getNodeDescriptor: s,
      expressionEvaluator: o,
      parentNodeName: A.DRAWER
    });
  }
  return !1;
}
function En(e) {
  return cn(A.DRAWER_FIXED_PART, e);
}
function _o(e) {
  return cn(A.DRAWER_EXPANDABLE_PART, e);
}
function cn(e, t) {
  const { children: n, dataContext: r, expressionEvaluator: o, getNodeDescriptor: s, parentNodeName: a } = t;
  if (a !== A.DRAWER)
    throw Error(`"${e}" must be a child of "${A.DRAWER}"`);
  return de({
    nodes: n,
    dataContext: r,
    getNodeDescriptor: s,
    expressionEvaluator: o,
    parentNodeName: e
  });
}
function Ao(e) {
  const t = e ? e.filter((o) => !Jt(o)) : [], n = Pe(t, A.DRAWER_FIXED_PART), r = Pe(t, A.DRAWER_EXPANDABLE_PART);
  if (!(t.length === 2 && n && r))
    throw Error(`Invalid "${A.DRAWER}" component syntax`);
}
function dn() {
  var e;
  return !!(typeof window < "u" && ((e = window == null ? void 0 : window.document) != null && e.createElement));
}
var ye = /* @__PURE__ */ ((e) => (e.INITIAL_STATE = "initialState", e))(ye || {}), M = /* @__PURE__ */ ((e) => (e.ACTIVE_BACKGROUND = "activeBackground", e.BACKGROUND = "background", e.HOVER_BACKGROUND = "hoverBackground", e.BORDER_RADIUS = "borderRadius", e.BORDER_COLOR = "borderColor", e.BORDER_WIDTH = "borderWidth", e.ICON_COLOR = "iconColor", e.PADDING = "padding", e))(M || {}), ee = /* @__PURE__ */ ((e) => (e.BACKGROUND = "background", e.BORDER_RADIUS = "borderRadius", e.BORDER_COLOR = "borderColor", e.BORDER_WIDTH = "borderWidth", e.PADDING = "padding", e))(ee || {});
const rt = new V({
  [M.ACTIVE_BACKGROUND]: { style: R.GREY_100, styleType: E.COLOR },
  [M.BACKGROUND]: { style: R.TRANSPARENT, styleType: E.COLOR },
  [M.HOVER_BACKGROUND]: { style: R.GREY_100, styleType: E.COLOR },
  [M.BORDER_COLOR]: { style: R.TRANSPARENT, styleType: E.COLOR },
  [M.BORDER_RADIUS]: {
    style: X.X_SMALL,
    styleType: E.BORDER_RADIUS
  },
  [M.BORDER_WIDTH]: { style: k.NONE, styleType: E.STROKE_WIDTH },
  [M.ICON_COLOR]: { style: x.DEFAULT_TEXT, styleType: E.COLOR },
  [M.PADDING]: { style: B.MEDIUM, styleType: E.SPACING }
}), ot = new V({
  [ee.BACKGROUND]: { style: R.TRANSPARENT, styleType: E.COLOR },
  [ee.BORDER_COLOR]: { style: R.TRANSPARENT, styleType: E.COLOR },
  [ee.BORDER_RADIUS]: {
    style: X.NONE,
    styleType: E.BORDER_RADIUS
  },
  [ee.BORDER_WIDTH]: {
    style: k.NONE,
    styleType: E.STROKE_WIDTH
  },
  [ee.PADDING]: { style: B.MEDIUM, styleType: E.SPACING }
});
function Tn(e) {
  const t = e.viewBox || "0 0 16 16";
  return /* @__PURE__ */ d("svg", { preserveAspectRatio: "xMidYMid meet", ...e, viewBox: t, children: /* @__PURE__ */ d(
    "path",
    {
      clipRule: "evenodd",
      d: `M1.64645 4.64645C1.84171 4.45118 2.15829 4.45118 2.35355 4.64645L8 10.2929L13.6464
          4.64645C13.8417 4.45118 14.1583 4.45118 14.3536 4.64645C14.5488 4.84171 14.5488 5.15829 14.3536
          5.35355L8.35355 11.3536C8.15829 11.5488 7.84171 11.5488 7.64645 11.3536L1.64645 5.35355C1.45118 5.15829
          1.45118 4.84171 1.64645 4.64645Z`,
      fillRule: "evenodd"
    }
  ) });
}
const Mt = 8, Ce = 4, He = 14, No = Rt(R.GREY_300);
function Oo(e) {
  const t = C(e[i.TEST_ID]), n = C(t, "content"), r = C(t, "icon"), o = q({ "aria-description": e[i.ARIA_DESCRIPTION] }), s = e.isInteractive && e.isExpanded, a = ct({
    to: {
      transform: s ? "rotate(0deg)" : "rotate(-90deg)"
    },
    config: {
      clamp: !0,
      friction: 20,
      tension: 200
    },
    onRest: e.onAnimationEnd
  }), l = s ? e[M.ACTIVE_BACKGROUND] : e[M.BACKGROUND], c = e.isInteractive ? "pointer" : "default", I = e.isInteractive ? e[M.ICON_COLOR] : No, u = e.isInteractive ? e.onClick : void 0;
  return /* @__PURE__ */ W(
    So,
    {
      ...o,
      id: e[i.ELEMENT_ID],
      className: N(e[i.CLASS_NAME]),
      "data-testid": t,
      onClick: u,
      $background: l,
      $borderRadius: e[M.BORDER_RADIUS],
      $borderWidth: e[M.BORDER_WIDTH],
      $borderColor: e[M.BORDER_COLOR],
      $cursor: c,
      $hoverBackground: e[M.HOVER_BACKGROUND],
      children: [
        /* @__PURE__ */ d(fo, { "data-testid": n, $padding: e[M.PADDING], children: e.children }),
        /* @__PURE__ */ d(Do, { "data-testid": r, style: a, $fillColor: I, children: /* @__PURE__ */ d(Tn, {}) })
      ]
    }
  );
}
const Do = D(Ke.div)`
  display: flex;
  fill: ${(e) => e.$fillColor};
  height: ${He + 2 * Ce}px;
  min-width: ${He + 2 * Ce}px;
  padding: ${Ce}px;
  position: relative;
  width: ${He + 2 * Ce}px;
`, So = D(g)`
  align-items: center;
  cursor: ${(e) => e.$cursor};
  display: flex;

  background: ${(e) => e.$background || "transparent"};
  border-color: ${(e) => e.$borderColor || "transparent"};
  border-radius: ${(e) => e.$borderRadius || "0"};
  border-width: ${(e) => e.$borderWidth || "0"};
  padding-right: ${Ce}px;

  &:hover {
    background: ${(e) => e.$hoverBackground || e.$background || "transparent"};
  }
`, fo = D(g)`
  max-width: calc(100% - ${He + Mt + 2 * Ce}px);
  margin-right: ${Mt}px;
  padding: ${(e) => `${e.$padding} 2px ${e.$padding} ${e.$padding}` || "0"};
  width: 100%;
`;
function Rn(e, t, n, r) {
  const o = $e(0), s = {
    height: "auto"
  }, a = $e(e), l = !e && !a.current, [, c] = Ue({}), I = ct({
    to: {
      opacity: e ? 0 : 1,
      height: e ? 0 : o.current || 0
    },
    config: {
      clamp: !0,
      friction: 20,
      tension: n || 200
    },
    onRest: () => {
      r && r(), a.current = e, e || c({});
    }
  });
  return Nr(() => {
    if (!(t != null && t.current))
      return;
    const u = o.current;
    o.current = t.current.offsetHeight || 0, u !== o.current && c({});
  }, [t]), l ? s : I;
}
function Co({
  fixedPart: e,
  expandablePart: t,
  isExpanded: n,
  onAnimationEnd: r,
  ...o
}) {
  const s = !!(t != null && t.content), [a, l] = Ue(s && n), c = $e(null), I = C(o[i.TEST_ID]), u = C(I, "fixed"), T = C(I, "expandable"), O = C(I, "expandable-content"), L = q({ "aria-description": o[i.ARIA_DESCRIPTION] }), S = q({ "aria-description": e.props[i.ARIA_DESCRIPTION] }), y = { [i.TEST_ID]: u }, p = () => {
    l((ve) => !ve);
  }, m = r && s, K = yt(), re = yt(), fe = m ? K.resolve : void 0, Te = m ? re.resolve : void 0;
  m && Promise.all([K.promise, re.promise]).then(() => r());
  const Fe = Rn(
    !a,
    c,
    200,
    Te
  ), be = s ? /* @__PURE__ */ d($o, { "data-testid": T, style: Fe, children: /* @__PURE__ */ d("div", { ref: c, children: /* @__PURE__ */ d(
    po,
    {
      "data-testid": O,
      $background: t.props[ee.BACKGROUND],
      $borderColor: t.props[ee.BORDER_COLOR],
      $borderRadius: t.props[ee.BORDER_RADIUS],
      $borderWidth: t.props[ee.BORDER_WIDTH],
      $padding: t.props[ee.PADDING],
      children: t.content
    }
  ) }) }) : null;
  return /* @__PURE__ */ W(
    ho,
    {
      ...L,
      id: o[i.ELEMENT_ID],
      className: o[i.CLASS_NAME],
      "data-testid": I,
      children: [
        /* @__PURE__ */ d(
          Oo,
          {
            ...e.props,
            ...S,
            ...y,
            isInteractive: s,
            isExpanded: s && a,
            onAnimationEnd: fe,
            onClick: s ? p : void 0,
            children: e.content
          }
        ),
        be
      ]
    }
  );
}
const ho = D(g)`
  & + & {
    margin-top: 4px;
  }
`, po = D(g)`
  background: ${(e) => e.$background || "transparent"};
  border-color: ${(e) => e.$borderColor || "transparent"};
  border-radius: ${(e) => e.$borderRadius || "0"};
  border-width: ${(e) => e.$borderWidth || "0"};
  padding: ${(e) => `0 ${e.$padding || "0"} ${e.$padding || "0"} ${e.$padding || "0"}`};

  margin-top: 8px;
`, $o = D(Ke.div)`
  overflow: hidden;
`, Be = [
  i.ARIA_DESCRIPTION,
  i.CLASS_NAME,
  i.ELEMENT_ID,
  i.TEST_ID,
  i.CONDITIONAL_RENDERING_EXPRESSION
], go = [...Be, ye.INITIAL_STATE], Pt = [...Be, ...rt.styleAttributeNames], Ut = [...Be, ...ot.styleAttributeNames];
function mo(e) {
  if (!ln(e))
    return null;
  const { attributes: t, children: n, dataContext: r, hostAppConfig: o, getNodeDescriptor: s, expressionEvaluator: a } = e, l = Pe(n, A.DRAWER_FIXED_PART), c = Pe(n, A.DRAWER_EXPANDABLE_PART), I = de({
    nodes: c == null ? void 0 : c.children,
    dataContext: r,
    getNodeDescriptor: s,
    expressionEvaluator: a
  }), u = Je(
    A.DRAWER,
    t,
    go,
    {},
    {},
    o
  ), T = Je(
    A.DRAWER_FIXED_PART,
    l == null ? void 0 : l.attributes,
    Pt,
    rt.styleValues,
    rt.styleTypes,
    o
  ), O = Je(
    A.DRAWER_EXPANDABLE_PART,
    c == null ? void 0 : c.attributes,
    Ut,
    ot.styleValues,
    ot.styleTypes,
    o
  ), L = yo(u), S = F(T, Pt), y = F(O, Ut), p = dn() && I, m = r.$index === 0, K = p && (L[ye.INITIAL_STATE] === ue.EXPANDED || m && L[ye.INITIAL_STATE] === ue.EXPAND_FIRST), re = ge({
    nodes: l == null ? void 0 : l.children,
    dataContext: r,
    hostAppConfig: o,
    getNodeDescriptor: s,
    expressionEvaluator: a
  }), fe = p ? ge({
    nodes: c == null ? void 0 : c.children,
    dataContext: r,
    hostAppConfig: o,
    getNodeDescriptor: s,
    expressionEvaluator: a
  }) : null;
  return /* @__PURE__ */ d(
    Co,
    {
      ...L,
      fixedPart: { content: re, props: S },
      expandablePart: { content: fe, props: y },
      isExpanded: K
    }
  );
}
function Je(e, t, n, r, o, s) {
  if (!t)
    return {};
  const a = ce(t, Be), l = ie(e, a, s), c = oe(n, l, r), I = se(c, o, s);
  return { ...c, ...I };
}
function yo(e) {
  return {
    ...F(e, Be),
    [ye.INITIAL_STATE]: De(
      e,
      ye.INITIAL_STATE,
      [ue.COLLAPSED, ue.EXPANDED, ue.EXPAND_FIRST],
      ue.COLLAPSED
    )
  };
}
var $ = /* @__PURE__ */ ((e) => (e.DEFAULT_URL = "defaultUrl", e.IMAGE_SIZE = "size", e.IMAGE_SHAPE = "shape", e.FIT_MODE = "mode", e.DISPLAY_ERROR = "displayError", e.IMAGE_URL = "url", e))($ || {}), Ae = /* @__PURE__ */ ((e) => (e.BORDER_RADIUS = "borderRadius", e.BORDER_COLOR = "borderColor", e.BORDER_WIDTH = "borderWidth", e))(Ae || {});
function bo(e) {
  const t = e.viewBox || "0 0 16 16";
  return /* @__PURE__ */ d("svg", { preserveAspectRatio: "xMidYMid meet", fill: "none", ...e, viewBox: t, children: /* @__PURE__ */ d(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.00129 14.9996H14.0001C14.7434 14.9996 15.2269 14.2173 14.8945 13.5524L8.89512 1.55281C8.5266 0.81573 7.47476 0.81573 7.10624 1.55281L1.10685 13.5524C0.774423 14.2173 1.25792 14.9996 2.00129 14.9996ZM8.5093 12.459C8.5093 12.7392 8.28194 12.9665 8.00147 12.9665C7.72101 12.9665 7.49365 12.7392 7.49365 12.459C7.49365 12.1787 7.72101 11.9515 8.00147 11.9515C8.28194 11.9515 8.5093 12.1787 8.5093 12.459ZM8.50147 5.85719C8.50147 5.58105 8.27762 5.35719 8.00147 5.35719C7.72533 5.35719 7.50147 5.58105 7.50147 5.85719V9.92006C7.50147 10.1962 7.72533 10.4201 8.00147 10.4201C8.27762 10.4201 8.50147 10.1962 8.50147 9.92006V5.85719Z"
    }
  ) });
}
function vo(e) {
  const t = e.viewBox || "0 0 16 16";
  return /* @__PURE__ */ d("svg", { preserveAspectRatio: "xMidYMid meet", fill: "none", ...e, viewBox: t, children: /* @__PURE__ */ d("path", { d: "M2 2c-.563 0-1 .469-1 1v7.313l2.094-2.126a1.304 1.304 0 0 1 1.781 0L7 10.313l4.094-4.126a1.304 1.304 0 0 1 1.781 0L15 8.313V3c0-.531-.469-1-1-1H2zm-1 9.719V13c0 .563.438 1 1 1h1.281l3-3-2.125-2.094a.245.245 0 0 0-.343 0L1 11.72zm11.156-4.813a.245.245 0 0 0-.344 0L4.689 14H14c.531 0 1-.438 1-1V9.719l-2.844-2.813zM0 3c0-1.094.875-2 2-2h12c1.094 0 2 .906 2 2v10c0 1.125-.906 2-2 2H2c-1.125 0-2-.875-2-2V3zm5 1.5c0-.25-.25-.5-.5-.5-.281 0-.5.25-.5.5 0 .281.219.5.5.5.25 0 .5-.219.5-.5zm-2 0c0-.531.281-1 .75-1.281.438-.281 1.031-.281 1.5 0 .438.281.75.75.75 1.281 0 .563-.313 1.031-.75 1.313-.469.28-1.063.28-1.5 0A1.496 1.496 0 0 1 3 4.5z" }) });
}
function Go(e) {
  const t = e.viewBox || "0 0 135 140";
  return /* @__PURE__ */ W("svg", { preserveAspectRatio: "xMidYMid meet", fill: "#ccc", ...e, viewBox: t, children: [
    /* @__PURE__ */ W("rect", { width: "15", height: "120", y: "10", rx: "6", children: [
      /* @__PURE__ */ d(
        "animate",
        {
          attributeName: "height",
          begin: "0.5s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "120;110;100;90;80;70;60;50;40;140;120"
        }
      ),
      /* @__PURE__ */ d(
        "animate",
        {
          attributeName: "y",
          begin: "0.5s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "10;15;20;25;30;35;40;45;50;0;10"
        }
      )
    ] }),
    /* @__PURE__ */ W("rect", { width: "15", height: "120", x: "30", y: "10", rx: "6", children: [
      /* @__PURE__ */ d(
        "animate",
        {
          attributeName: "height",
          begin: "0.25s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "120;110;100;90;80;70;60;50;40;140;120"
        }
      ),
      /* @__PURE__ */ d(
        "animate",
        {
          attributeName: "y",
          begin: "0.25s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "10;15;20;25;30;35;40;45;50;0;10"
        }
      )
    ] }),
    /* @__PURE__ */ W("rect", { width: "15", height: "140", x: "60", rx: "6", children: [
      /* @__PURE__ */ d(
        "animate",
        {
          attributeName: "height",
          begin: "0s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "120;110;100;90;80;70;60;50;40;140;120"
        }
      ),
      /* @__PURE__ */ d(
        "animate",
        {
          attributeName: "y",
          begin: "0s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "10;15;20;25;30;35;40;45;50;0;10"
        }
      )
    ] }),
    /* @__PURE__ */ W("rect", { width: "15", height: "120", x: "90", y: "10", rx: "6", children: [
      /* @__PURE__ */ d(
        "animate",
        {
          attributeName: "height",
          begin: "0.25s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "120;110;100;90;80;70;60;50;40;140;120"
        }
      ),
      /* @__PURE__ */ d(
        "animate",
        {
          attributeName: "y",
          begin: "0.25s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "10;15;20;25;30;35;40;45;50;0;10"
        }
      )
    ] }),
    /* @__PURE__ */ W("rect", { width: "15", height: "120", x: "120", y: "10", rx: "6", children: [
      /* @__PURE__ */ d(
        "animate",
        {
          attributeName: "height",
          begin: "0.5s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "120;110;100;90;80;70;60;50;40;140;120"
        }
      ),
      /* @__PURE__ */ d(
        "animate",
        {
          attributeName: "y",
          begin: "0.5s",
          calcMode: "linear",
          dur: "1s",
          repeatCount: "indefinite",
          values: "10;15;20;25;30;35;40;45;50;0;10"
        }
      )
    ] })
  ] });
}
const It = Rt(R.GREY_300), Mo = It, Po = It, xt = "40%";
function Uo(e) {
  const [t, n] = Ue({
    isError: !1,
    loadingState: "initial"
    /* INITIAL */
  }), r = $e(null), o = e[i.TEST_ID], s = q({ "aria-description": e[i.ARIA_DESCRIPTION] }), a = C(o), l = C(o, "loader"), c = C(o, "placeholder"), I = C(o, "image"), u = C(o, "error"), T = e[$.IMAGE_SHAPE] === Ge.ROUND, O = T ? "50%" : e[Ae.BORDER_RADIUS], L = e[Ae.BORDER_COLOR], S = e[Ae.BORDER_WIDTH], y = e[$.FIT_MODE] === Me.FILL ? "cover" : "scale-down", p = N(e[$.IMAGE_URL]) || N(e[$.DEFAULT_URL]) || void 0;
  let m = "auto", K = "100%";
  const re = e[$.IMAGE_SIZE];
  re === te.AUTO || ([K, m] = Pr(re));
  const Te = xo(K, m), be = t.loadingState === "initial" || t.loadingState === "finished" && t.isError && !e[$.DISPLAY_ERROR] ? /* @__PURE__ */ d(Ho, { "data-testid": c, $size: Te }) : null, ve = t.loadingState === "loading" ? /* @__PURE__ */ d(
    Wo,
    {
      "aria-description": "The image is being loaded",
      "data-testid": l,
      $size: Te
    }
  ) : null, ae = t.isError && e[$.DISPLAY_ERROR] ? /* @__PURE__ */ d(
    Fo,
    {
      "aria-description": "Error while loading the image",
      "data-testid": u,
      $size: Te
    }
  ) : null;
  return Ht(() => {
    r.current && p && t.loadingState === "initial" && (r.current.src = p, n({ loadingState: "loading", isError: !1 }));
  }, [p, t.loadingState]), /* @__PURE__ */ W(
    Bo,
    {
      ...s,
      id: e[i.ELEMENT_ID],
      className: e[i.CLASS_NAME],
      "data-state": t.loadingState,
      "data-testid": a,
      $aspect: T ? "1/1" : "auto",
      $borderColor: L,
      $borderRadius: O,
      $borderWidth: S,
      $height: T ? K : m,
      $width: K,
      children: [
        be,
        ve,
        /* @__PURE__ */ d(
          wo,
          {
            "data-testid": I,
            referrerPolicy: "no-referrer",
            ref: r,
            $aspect: T ? "1/1" : "auto",
            $fitMode: y,
            $height: T ? K : m,
            $width: K,
            $visible: t.loadingState === "finished" && !t.isError,
            onLoad: () => {
              n({ loadingState: "finished", isError: !1 }), e.onFinished && setTimeout(e.onFinished, 0);
            },
            onError: () => {
              n({ loadingState: "finished", isError: !0 }), e.onFinished && setTimeout(e.onFinished, 0);
            }
          }
        ),
        ae
      ]
    }
  );
}
function xo(e, t) {
  if (e.includes("%") || t.includes("%"))
    return xt;
  const n = e.match(/([0-9]+)/), r = t.match(/([0-9]+)/);
  if (!(n != null && n.length) || !(r != null && r.length))
    return xt;
  const o = Math.min(Number.parseInt(n[0]), Number.parseInt(r[0])), s = 32, a = 120, l = 80, c = 40, I = (c - l) / (a - s);
  return `${o >= a ? c : l + I * (o - s)}%`;
}
const Bo = D(g)`
  align-content: center;
  align-items: center;
  aspect-ratio: ${(e) => e.$aspect};
  border-color: ${(e) => e.$borderColor || "transparent"};
  border-radius: ${(e) => e.$borderRadius || "0"};
  border-style: ${(e) => e.$borderWidth ? "solid" : "none"};
  border-width: ${(e) => e.$borderWidth || "0"};
  display: flex;
  height: ${(e) => e.$height};
  justify-content: center;
  justify-items: center;
  max-width: ${(e) => e.$width};
  overflow: hidden;
  position: relative;
  width: ${(e) => e.$width};
`, wo = D.img`
  align-self: center;
  aspect-ratio: ${(e) => e.$aspect};
  display: ${(e) => e.$visible ? "flex" : "none"};
  height: ${(e) => e.$height};
  margin: 0 auto;
  object-fit: ${(e) => e.$fitMode || "scale-down"};
  width: ${(e) => e.$width};
`, Fo = D(bo)`
  display: flex;
  align-self: center;
  height: ${(e) => e.$size};
  margin: 0 auto;
  path {
    fill: ${Mo};
  }
  width: ${(e) => e.$size};
`, Wo = D(Go)`
  display: flex;
  align-self: center;
  fill: ${Po};
  height: ${(e) => e.$size};
  margin: 0 auto;
  width: calc(${(e) => e.$size} - 10%);
`, Ho = D(vo)`
  display: flex;
  align-self: center;
  height: ${(e) => e.$size};
  margin: 0 auto;
  path {
    fill: ${It};
  }
  width: ${(e) => e.$size};
`, it = new V({
  [Ae.BORDER_COLOR]: { style: R.GREY_300, styleType: E.COLOR },
  [Ae.BORDER_RADIUS]: { style: X.SMALL, styleType: E.BORDER_RADIUS },
  [Ae.BORDER_WIDTH]: { style: k.THIN, styleType: E.STROKE_WIDTH }
}), Xo = new V({
  [$.IMAGE_SIZE]: { style: te.AUTO, styleType: E.IMAGE_SIZE }
}), ut = [
  i.ARIA_DESCRIPTION,
  i.CLASS_NAME,
  i.DATA_SOURCE,
  i.ELEMENT_ID,
  i.TEST_ID,
  i.CONDITIONAL_RENDERING_EXPRESSION
], ko = [
  $.DEFAULT_URL,
  $.IMAGE_SIZE,
  $.IMAGE_SHAPE,
  $.FIT_MODE
], In = it.styleAttributeNames, Yo = [...ut, ...ko, ...In];
function un(e) {
  const { attributes: t, dataContext: n, expressionEvaluator: r } = e, o = f(t, i.CONDITIONAL_RENDERING_EXPRESSION);
  return o ? r.evaluateCondition(o, n) : !0;
}
function Vo(e) {
  const { attributes: t, dataContext: n, hostAppConfig: r, options: o } = e;
  if (!un(e))
    return null;
  const s = ce(t, [
    ...ut,
    $.DEFAULT_URL,
    $.IMAGE_SIZE
  ]), a = ie(A.IMAGE, s, r), l = oe(Yo, a, it.styleValues), c = { ...it.styleTypes, ...Xo.styleTypes }, I = se(l, c, r), u = { ...l, ...I }, T = Ko(u), O = T[i.DATA_SOURCE] && h(n, T[i.DATA_SOURCE], ""), L = {
    ...T,
    [$.IMAGE_URL]: O,
    [$.DISPLAY_ERROR]: !!(o != null && o.debugMode)
  };
  return /* @__PURE__ */ d(Uo, { ...L });
}
function Ko(e) {
  const t = F(e, ut), n = F(e, In);
  return {
    ...t,
    ...n,
    [$.FIT_MODE]: De(
      e,
      $.FIT_MODE,
      [Me.FIT, Me.FILL],
      Me.FIT
    ),
    [$.IMAGE_SHAPE]: De(
      e,
      $.IMAGE_SHAPE,
      [Ge.ROUND, Ge.RECT],
      Ge.RECT
    ),
    [$.IMAGE_SIZE]: f(e, $.IMAGE_SIZE, te.AUTO)
  };
}
var ne = /* @__PURE__ */ ((e) => (e.CAN_COLLAPSE = "collapsible", e.TITLE = "title", e))(ne || {}), w = /* @__PURE__ */ ((e) => (e.BACKGROUND = "background", e.BORDER_RADIUS = "borderRadius", e.BORDER_COLOR = "borderColor", e.BORDER_WIDTH = "borderWidth", e.PADDING = "padding", e))(w || {}), Y = /* @__PURE__ */ ((e) => (e.TITLE_COLOR = "titleColor", e.TITLE_FONT_SIZE = "titleFontSize", e.TITLE_FONT_WEIGHT = "titleFontWeight", e.TITLE_SPACING = "titleSpacing", e))(Y || {});
function zo(e) {
  const [t, n] = Ue(!1), r = $e(null), [o, s] = me(e[Y.TITLE_FONT_SIZE]), a = e[i.TEST_ID], l = q({ "aria-description": e[i.ARIA_DESCRIPTION] }), c = C(a), I = C(a, "content"), u = C(a, "header"), T = C(a, "icon"), O = o, L = `calc(${o} * 0.75)`, S = () => {
    n((m) => !m);
  }, y = Rn(t, r, 200, e.onAnimationEnd), p = ct({
    to: {
      transform: t ? "rotate(-90deg)" : "rotate(0deg)"
    },
    config: {
      clamp: !0,
      friction: 20,
      tension: 200
    }
  });
  return /* @__PURE__ */ W(
    ti,
    {
      ...l,
      id: e[i.ELEMENT_ID],
      className: e[i.CLASS_NAME],
      "data-collapsible": !0,
      "data-testid": c,
      $background: e[w.BACKGROUND],
      $borderColor: e[w.BORDER_COLOR],
      $borderRadius: e[w.BORDER_RADIUS],
      $borderWidth: e[w.BORDER_WIDTH],
      $padding: e[w.PADDING],
      children: [
        /* @__PURE__ */ W(ei, { onClick: S, children: [
          /* @__PURE__ */ d(
            Qo,
            {
              "data-testid": u,
              $color: e[Y.TITLE_COLOR],
              $fontSize: o,
              $fontWeight: e[Y.TITLE_FONT_WEIGHT],
              $iconMargin: O,
              $iconSize: L,
              $lineHeight: s,
              children: N(e[ne.TITLE])
            }
          ),
          /* @__PURE__ */ d(Jo, { $width: o }),
          /* @__PURE__ */ d(
            Zo,
            {
              "data-testid": T,
              $size: L,
              $fillColor: e[Y.TITLE_COLOR],
              style: p,
              children: /* @__PURE__ */ d(Tn, {})
            }
          )
        ] }),
        /* @__PURE__ */ d(qo, { "data-testid": I, style: y, children: /* @__PURE__ */ d("div", { ref: r, children: /* @__PURE__ */ d(jo, { $headerMargin: e[Y.TITLE_SPACING], children: e.children }) }) })
      ]
    }
  );
}
const Zo = D(Ke.div)`
  display: flex;
  fill: ${(e) => e.$fillColor};
  height: ${(e) => e.$size};
  min-width: ${(e) => e.$size};
  position: relative;
  width: ${(e) => e.$size};
`, jo = D(g)`
  margin-top: ${(e) => e.$headerMargin};
`, qo = D(Ke.div)`
  overflow: hidden;
`, Jo = D(g)`
  display: flex;
  width: ${(e) => e.$width};
`, Qo = D(g)`
  color: ${(e) => e.$color};
  flex-basis: calc(100% - calc(${(e) => e.$iconSize} + ${(e) => e.$iconMargin}));
  font-size: ${(e) => e.$fontSize};
  font-weight: ${(e) => e.$fontWeight};
  line-height: ${(e) => e.$lineHeight};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`, ei = D(g)`
  align-items: center;
  cursor: pointer;
  display: flex;
  position: relative;
`, ti = D(g)`
  background: ${(e) => e.$background || "transparent"};
  border-color: ${(e) => e.$borderColor || "transparent"};
  border-radius: ${(e) => e.$borderRadius || "0"};
  border-width: ${(e) => e.$borderWidth || "0"};
  padding: ${(e) => e.$padding || "0"};
`, st = new V({
  [w.BACKGROUND]: { style: R.TRANSPARENT, styleType: E.COLOR },
  [w.BORDER_COLOR]: { style: R.TRANSPARENT, styleType: E.COLOR },
  [w.BORDER_RADIUS]: { style: X.NONE, styleType: E.BORDER_RADIUS },
  [w.BORDER_WIDTH]: { style: k.NONE, styleType: E.STROKE_WIDTH },
  [w.PADDING]: { style: B.MEDIUM, styleType: E.SPACING }
}), at = new V({
  [Y.TITLE_COLOR]: { style: x.DEFAULT_TEXT, styleType: E.COLOR },
  [Y.TITLE_FONT_SIZE]: { style: J.DEFAULT, styleType: E.FONT_SIZE },
  [Y.TITLE_FONT_WEIGHT]: {
    style: Q.SEMI_BOLD,
    styleType: E.FONT_WEIGHT
  },
  [Y.TITLE_SPACING]: { style: B.SMALL, styleType: E.SPACING }
});
function ni(e) {
  const [t, n] = me(e[Y.TITLE_FONT_SIZE]), r = e[i.TEST_ID], o = q({ "aria-description": e[i.ARIA_DESCRIPTION] }), s = C(r), a = C(r, "header"), l = C(r, "content"), c = N(e[ne.TITLE]), I = c ? /* @__PURE__ */ d(
    ri,
    {
      className: e[i.CLASS_NAME],
      "data-testid": a,
      $color: e[Y.TITLE_COLOR],
      $fontSize: t,
      $fontWeight: e[Y.TITLE_FONT_WEIGHT],
      $lineHeight: n,
      $marginBottom: e[Y.TITLE_SPACING],
      children: c
    }
  ) : null;
  return /* @__PURE__ */ W(
    oi,
    {
      ...o,
      id: e[i.ELEMENT_ID],
      className: e[i.CLASS_NAME],
      "data-static": !0,
      "data-testid": s,
      $background: e[w.BACKGROUND],
      $borderColor: e[w.BORDER_COLOR],
      $borderRadius: e[w.BORDER_RADIUS],
      $borderWidth: e[w.BORDER_WIDTH],
      $padding: e[w.PADDING],
      children: [
        I,
        /* @__PURE__ */ d("div", { "data-testid": l, children: e.children })
      ]
    }
  );
}
const ri = D(g)`
  color: ${(e) => e.$color};
  font-size: ${(e) => e.$fontSize};
  font-weight: ${(e) => e.$fontWeight};
  line-height: ${(e) => e.$lineHeight};
  margin-bottom: ${(e) => e.$marginBottom};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`, oi = D(g)`
  background: ${(e) => e.$background || "transparent"};
  border-color: ${(e) => e.$borderColor || "transparent"};
  border-radius: ${(e) => e.$borderRadius || "0"};
  border-width: ${(e) => e.$borderWidth || "0"};
  padding: ${(e) => e.$padding || "0"};
`, Lt = [
  i.ARIA_DESCRIPTION,
  i.CLASS_NAME,
  i.ELEMENT_ID,
  i.TEST_ID,
  i.CONDITIONAL_RENDERING_EXPRESSION
], Ln = [ne.CAN_COLLAPSE, ne.TITLE], _n = st.styleAttributeNames, An = at.styleAttributeNames, ii = [
  ...Lt,
  ...Ln,
  ..._n,
  ...An
];
function Nn(e) {
  const { attributes: t, children: n, dataContext: r, expressionEvaluator: o, getNodeDescriptor: s } = e, a = f(t, i.CONDITIONAL_RENDERING_EXPRESSION);
  return (a ? o.evaluateCondition(a, r) : !0) ? de({
    parentNodeName: A.SECTION,
    nodes: n,
    dataContext: r,
    getNodeDescriptor: s,
    expressionEvaluator: o
  }) : !1;
}
function si(e) {
  const { attributes: t, children: n, dataContext: r, hostAppConfig: o, getNodeDescriptor: s, expressionEvaluator: a } = e;
  if (!Nn(e))
    return null;
  const l = { ...t, ...at.styleValues }, c = ce(l, [...Lt, ...Ln]), I = ie(A.SECTION, c, o), u = oe(
    ii,
    I,
    st.styleValues
  ), T = { ...st.styleTypes, ...at.styleTypes }, O = se(u, T, o), L = { ...u, ...O }, S = ge({
    parentNodeName: A.SECTION,
    nodes: n,
    dataContext: r,
    hostAppConfig: o,
    getNodeDescriptor: s,
    expressionEvaluator: a
  });
  if (!S.length)
    return null;
  const y = ai(L, r, a), m = y[ne.CAN_COLLAPSE] ? zo : ni;
  return /* @__PURE__ */ d(m, { ...y, children: S });
}
function ai(e, t, n) {
  const r = N(e[ne.TITLE]), o = r && N(n.interpolateString(r, t)), s = Oe(e, ne.CAN_COLLAPSE), a = !!o && s && dn(), l = F(e, Lt), c = F(e, [
    ..._n,
    ...An
  ]);
  return {
    ...l,
    ...c,
    [i.ELEMENT_ID]: f(e, i.ELEMENT_ID),
    [ne.TITLE]: o,
    [ne.CAN_COLLAPSE]: a
  };
}
function On(e, t, n, r) {
  const { attributes: o, dataContext: s, expressionEvaluator: a } = t;
  vr(o, n, e);
  const l = f(o, i.DATA_SOURCE), c = f(o, i.CONDITIONAL_RENDERING_EXPRESSION);
  if (!(c ? a.evaluateCondition(c, s) : !0))
    return !1;
  const u = h(s, l);
  return (u === void 0 || Et(u) || Xt(u) && kt(u)) && r(u);
}
var _ = /* @__PURE__ */ ((e) => (e.DISPLAY_STYLE = "displayStyle", e.LABEL = "label", e.LINKIFY_VALUE_FLAG = "linkifyValue", e.LINK_TARGET = "linkTarget", e.LINK_URL = "linkUrl", e.MAX_LINES = "maxLines", e.MULTILINE_FLAG = "multiline", e.SCROLLABLE_FLAG = "scrollable", e.VALUE = "value", e))(_ || {}), b = /* @__PURE__ */ ((e) => (e.PADDING = "padding", e.LABEL_ALIGNMENT = "labelAlignment", e.LABEL_BACKGROUND = "labelBackground", e.LABEL_COLOR = "labelColor", e.LABEL_FONT_SIZE = "labelFontSize", e.LABEL_FONT_WEIGHT = "labelFontWeight", e.VALUE_ALIGNMENT = "valueAlignment", e.VALUE_BACKGROUND = "valueBackground", e.VALUE_COLOR = "valueColor", e.VALUE_FONT_SIZE = "valueFontSize", e.VALUE_FONT_WEIGHT = "valueFontWeight", e.LINK_DECORATION = "linkDecoration", e.LINK_HOVER_COLOR = "linkHoverColor", e.LINK_HOVER_DECORATION = "linkHoverDecoration", e))(b || {}), Se = /* @__PURE__ */ ((e) => (e.LINK_TEXT = "linkText", e.OPEN_IN_PLACE = "openInPlace", e))(Se || {});
function li(e) {
  const { value: t } = e;
  if (!t)
    return null;
  const r = t.split(/\r\n|\r|\n/).reduce((o, s, a) => (a && o.push(/* @__PURE__ */ d("br", {}, `break-${a}`)), o.push(/* @__PURE__ */ d(Le, { children: s }, `part-${a}`)), o), []);
  return /* @__PURE__ */ d(Le, { children: r });
}
function Dn(e) {
  const { id: t, aria: n, className: r, direction: o, displayStyle: s, label: a, multiline: l, maxLines: c, scrollable: I, testId: u, value: T } = e, { linkifyValue: O, linkDecoration: L, linkHoverColor: S, linkHoverDecoration: y, linkTarget: p, linkUrl: m } = e, {
    padding: K,
    labelAlignment: re,
    labelBackground: fe,
    labelColor: Te,
    labelFontSize: Fe,
    labelFontWeight: be,
    valueAlignment: ve,
    valueBackground: ae,
    valueColor: At,
    valueFontSize: xn,
    valueFontWeight: Bn
  } = e, qe = N(a), Nt = N(T), wn = `${N(r)} datavalue`, Re = s === j.STACKED, Fn = Re ? ci : Ei, Wn = Re ? Ri : Ti, Hn = Re ? ui : Ii, [Xn, kn] = me(Fe), [Yn, Ot] = me(xn), Vn = ae && ae !== R.INHERIT && ae !== R.TRANSPARENT && ae.toLowerCase() !== "white" && ae.toLowerCase() !== "#ffff", Dt = (l || Re) && Vn, Kn = Re ? "0 0 2px 0" : "0 4px 0 0", zn = Re ? Dt ? "4px" : "0" : Dt ? "4px 6px" : "0 0 0 4px", St = Re ? { dir: o || "auto" } : {}, Zn = q({ "aria-description": n }), jn = C(u), qn = C(u, "data-label"), Jn = C(u, "link"), Qn = C(u, "data-value"), er = qe ? /* @__PURE__ */ d(
    Wn,
    {
      ...St,
      className: "label",
      "data-testid": qn,
      $alignment: re,
      $background: fe,
      $color: Te,
      $fontSize: Xn,
      $fontWeight: be,
      $lineHeight: kn,
      $multiline: l,
      $padding: Kn,
      children: qe
    }
  ) : null, ft = l ? /* @__PURE__ */ d(li, { value: Nt }) : Nt, Ct = O ? /* @__PURE__ */ d(
    Li,
    {
      "data-testid": Jn,
      href: m,
      target: p,
      rel: "noreferrer",
      $color: At,
      $decoration: L,
      $hoverColor: S,
      $hoverDecoration: y,
      children: ft
    }
  ) : ft, tr = I && l ? /* @__PURE__ */ d(di, { $lineHeight: Ot, $maxLines: c, children: Ct }) : /* @__PURE__ */ d(Vt, { clamp: l ? Math.max(c, 1) : 1, useNativeClamp: !0, children: Ct }), nr = /* @__PURE__ */ d(
    Hn,
    {
      ...St,
      className: "value",
      "data-testid": Qn,
      $alignment: ve,
      $background: ae,
      $color: At,
      $hasLabel: !!qe,
      $fontSize: Yn,
      $fontWeight: Bn,
      $lineHeight: Ot,
      $multiline: l,
      $padding: zn,
      children: tr
    }
  );
  return /* @__PURE__ */ W(
    Fn,
    {
      ...Zn,
      id: t,
      className: wn,
      "data-testid": jn,
      dir: o || "auto",
      $padding: K,
      children: [
        er,
        nr
      ]
    }
  );
}
const Ei = D(g)`
  align-items: baseline;
  display: flex;
  flex-basis: 100%;
  justify-content: space-between;
  padding: ${(e) => e.$padding || "0"};
  word-break: break-all;
`, ci = D(g)`
  display: block;
  padding: ${(e) => e.$padding || "0"};
  word-break: break-all;
`, Ze = Lr`
  background: ${(e) => e.$background || "inherit"};
  color: ${(e) => e.$color};
  font-size: ${(e) => e.$fontSize};
  font-weight: ${(e) => e.$fontWeight};
  line-height: ${(e) => e.$lineHeight || "normal"};
  padding: ${(e) => e.$padding || "none"};
  text-align: ${(e) => e.$alignment || "initial"};
`, di = D(g)`
  box-sizing: border-box;
  max-height: ${(e) => {
  const t = N(e.$lineHeight), n = t && t !== "normal" ? t : "1.2";
  return /px|em|rem|ex|rex/i.test(n) ? `calc(${e.$maxLines} * ${n})` : `calc(${e.$maxLines}em * ${n})`;
}};
  overflow: scroll;
  padding: 0;
  scroll-behavior: smooth;
`, Ti = D(g)`
  ${Ze};
  flex-basis: 40%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`, Ri = D(g)`
  ${Ze};
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`, Ii = D(g)`
  ${Ze};
  flex-basis: ${(e) => e.$hasLabel ? "60%" : "100%"};
`, ui = D(g)`
  ${Ze}'
  width: 100;
`, Li = D.a`
  color: ${(e) => e.$color};
  cursor: pointer;
  text-decoration: ${(e) => e.$decoration || "initial"};

  &:hover {
    color: ${(e) => e.$hoverColor || e.$color};
    text-decoration: ${(e) => e.$hoverDecoration || e.$decoration || "initial"};
  }
`, _t = new V({
  [b.PADDING]: { style: B.X_SMALL, styleType: E.SPACING },
  [b.LABEL_ALIGNMENT]: { style: Z.LEFT, styleType: E.ALIGNMENT },
  [b.LABEL_BACKGROUND]: { style: R.INHERIT, styleType: E.COLOR },
  [b.LABEL_COLOR]: { style: x.DEFAULT_TEXT, styleType: E.COLOR },
  [b.LABEL_FONT_SIZE]: { style: J.DEFAULT, styleType: E.FONT_SIZE },
  [b.LABEL_FONT_WEIGHT]: {
    style: Q.REGULAR,
    styleType: E.FONT_WEIGHT
  },
  [b.VALUE_ALIGNMENT]: { style: Z.LEFT, styleType: E.ALIGNMENT },
  [b.VALUE_BACKGROUND]: { style: R.INHERIT, styleType: E.COLOR },
  [b.VALUE_COLOR]: { style: x.DEFAULT_TEXT, styleType: E.COLOR },
  [b.VALUE_FONT_SIZE]: { style: J.DEFAULT, styleType: E.FONT_SIZE },
  [b.VALUE_FONT_WEIGHT]: {
    style: Q.REGULAR,
    styleType: E.FONT_WEIGHT
  },
  [b.LINK_DECORATION]: {
    style: Ee.NONE,
    styleType: E.TEXT_DECORATION
  },
  [b.LINK_HOVER_COLOR]: {
    style: x.DEFAULT_TEXT,
    styleType: E.COLOR
  },
  [b.LINK_HOVER_DECORATION]: {
    style: Ee.NONE,
    styleType: E.TEXT_DECORATION
  }
}), je = new V(_t.styles), Sn = new V(_t.styles);
Sn.overrideStyles({
  [b.VALUE_BACKGROUND]: { style: R.GREY_100, styleType: E.COLOR }
});
const _i = [
  i.ARIA_DESCRIPTION,
  i.CLASS_NAME,
  i.DATA_SOURCE,
  i.TEXT_DIRECTION,
  i.TEST_ID,
  i.ELEMENT_ID,
  i.CONDITIONAL_RENDERING_EXPRESSION,
  _.DISPLAY_STYLE,
  _.LABEL,
  _.MAX_LINES,
  _.MULTILINE_FLAG,
  _.SCROLLABLE_FLAG
], Ai = [..._i, ...je.styleAttributeNames], Ni = [
  i.ARIA_DESCRIPTION,
  i.CLASS_NAME,
  i.DATA_SOURCE,
  i.ELEMENT_ID,
  i.TEST_ID,
  i.CONDITIONAL_RENDERING_EXPRESSION,
  _.LABEL
], fn = {
  ...je.styleValues,
  [i.TEXT_DIRECTION]: Ie.AUTO,
  [_.DISPLAY_STYLE]: j.ROW,
  [_.MAX_LINES]: "1",
  [_.MULTILINE_FLAG]: "false",
  [_.SCROLLABLE_FLAG]: "false"
}, Cn = {
  ...fn,
  ...Sn.styleValues,
  [_.DISPLAY_STYLE]: j.STACKED,
  [_.MAX_LINES]: "3",
  [_.MULTILINE_FLAG]: "true",
  [_.SCROLLABLE_FLAG]: "false"
}, Oi = {
  ...Cn,
  [_.SCROLLABLE_FLAG]: "true"
};
function hn(e) {
  const t = (n) => Et(n) && !!N(n) || Xt(n) && kt(n);
  return On(A.STRING_VALUE, e, [i.DATA_SOURCE], t);
}
function Di(e) {
  const { attributes: t, dataContext: n, hostAppConfig: r } = e;
  if (!hn(e))
    return null;
  const o = ce(t, Ni), s = ie(A.STRING_VALUE, o, r), a = Oe(s, _.MULTILINE_FLAG), l = Oe(s, _.SCROLLABLE_FLAG), I = oe(Ai, s, a ? l ? Oi : Cn : fn), u = se(I, je.styleTypes, r), T = { ...I, ...u }, O = f(T, i.DATA_SOURCE), L = Si(T), S = String(h(n, O, "")).trim();
  return /* @__PURE__ */ d(Dn, { ...L, value: S });
}
function Si(e) {
  const t = Oe(e, _.MULTILINE_FLAG, !1), n = t ? Math.max(1, Zt(e, _.MAX_LINES)) : 1, r = t ? j.STACKED : j.ROW, o = F(e, je.styleAttributeNames);
  return {
    // Functional props
    [i.ARIA_DESCRIPTION]: f(e, i.ARIA_DESCRIPTION),
    [i.TEXT_DIRECTION]: ze(e, i.TEXT_DIRECTION),
    [_.DISPLAY_STYLE]: De(
      e,
      _.DISPLAY_STYLE,
      [j.STACKED, j.ROW],
      r
    ),
    [i.ELEMENT_ID]: f(e, i.ELEMENT_ID),
    [_.LABEL]: f(e, _.LABEL),
    [_.LINKIFY_VALUE_FLAG]: !1,
    [_.MULTILINE_FLAG]: t,
    [_.MAX_LINES]: Math.min(n, br),
    [_.SCROLLABLE_FLAG]: Oe(e, _.SCROLLABLE_FLAG),
    [i.TEST_ID]: f(e, i.TEST_ID),
    // Styling props
    ...o
  };
}
const we = new V(_t.styles);
we.overrideStyles({
  [b.VALUE_COLOR]: { style: x.PRIMARY, styleType: E.COLOR },
  [b.LINK_DECORATION]: {
    style: Ee.NONE,
    styleType: E.TEXT_DECORATION
  },
  [b.LINK_HOVER_COLOR]: {
    style: x.PRIMARY,
    styleType: E.COLOR
  },
  [b.LINK_HOVER_DECORATION]: {
    style: Ee.UNDERLINED,
    styleType: E.TEXT_DECORATION
  }
});
const pn = new Or();
pn.tlds(Dr).add("mailto:", null).add("ftp:", null);
function $n(e) {
  const t = e.trim();
  if (!t)
    return "";
  const n = pn.match(t);
  return n && n[0].url || t;
}
function fi(e) {
  const t = $n(e);
  if (!t)
    return "";
  const n = new URL(t), r = n.pathname === "/" ? "" : n.pathname;
  return `${n.hostname}${r}`;
}
const Ci = [
  i.ARIA_DESCRIPTION,
  i.CLASS_NAME,
  i.DATA_SOURCE,
  i.TEXT_DIRECTION,
  i.TEST_ID,
  i.ELEMENT_ID,
  i.CONDITIONAL_RENDERING_EXPRESSION,
  _.DISPLAY_STYLE,
  _.LABEL,
  _.LINK_URL,
  Se.LINK_TEXT,
  Se.OPEN_IN_PLACE
], hi = [...Ci, ...we.styleAttributeNames], pi = [
  i.ARIA_DESCRIPTION,
  i.CLASS_NAME,
  i.DATA_SOURCE,
  i.ELEMENT_ID,
  i.TEST_ID,
  i.CONDITIONAL_RENDERING_EXPRESSION,
  _.LABEL,
  _.LINK_URL,
  Se.LINK_TEXT
], $i = {
  ...we.styleValues,
  [i.TEXT_DIRECTION]: Ie.AUTO,
  [_.DISPLAY_STYLE]: j.ROW,
  [Se.OPEN_IN_PLACE]: "false"
};
function gn(e) {
  const { attributes: t, dataContext: n, expressionEvaluator: r } = e, o = N(f(t, _.LINK_URL)), s = o && N(r.interpolateString(o, n)), a = (l) => {
    if (!Er(l) && !qt(l))
      throw Error(`Inable to render <${A.LINK}>: invalid "${i.DATA_SOURCE}" attribute value`);
    return !!(l || s);
  };
  return On(A.LINK, e, [], a);
}
function gi(e) {
  const { attributes: t, dataContext: n, expressionEvaluator: r, hostAppConfig: o } = e;
  if (!gn(e))
    return null;
  const s = ce(t, pi), a = ie(A.LINK, s, o), l = oe(hi, a, $i), c = se(l, we.styleTypes, o), I = { ...l, ...c }, u = N(f(I, Se.LINK_TEXT)), T = N(r.interpolateString(u, n)), O = mi(I, n, r), L = fi(O[_.LINK_URL]);
  return /* @__PURE__ */ d(Dn, { ...O, value: T || L });
}
function mi(e, t, n) {
  const r = Oe(e, Se.OPEN_IN_PLACE, !1), o = N(f(e, _.LINK_URL)), s = o && N(n.interpolateString(o, t)), a = N(f(e, i.DATA_SOURCE)), l = String(h(t, a)), c = F(e, we.styleAttributeNames);
  return {
    // Functional props
    [i.ARIA_DESCRIPTION]: f(e, i.ARIA_DESCRIPTION),
    [i.TEXT_DIRECTION]: ze(e, i.TEXT_DIRECTION),
    [_.DISPLAY_STYLE]: De(
      e,
      _.DISPLAY_STYLE,
      [j.STACKED, j.ROW],
      j.ROW
    ),
    [i.ELEMENT_ID]: f(e, i.ELEMENT_ID),
    [_.LABEL]: f(e, _.LABEL),
    [_.MULTILINE_FLAG]: !1,
    [_.MAX_LINES]: 1,
    [_.SCROLLABLE_FLAG]: !1,
    [i.TEST_ID]: f(e, i.TEST_ID),
    [_.LINKIFY_VALUE_FLAG]: !0,
    [_.LINK_URL]: $n(s || l),
    [_.LINK_TARGET]: r ? void 0 : "_blank",
    // Styling props
    ...c
  };
}
function mn(e, t, n) {
  const { $root: r } = e;
  return Object.freeze({
    ...dt(t) ? t : {},
    $root: r,
    $parent: cr(e, "$root"),
    $index: n,
    $data: t
  });
}
const yn = ({
  attributes: e,
  children: t,
  parentNodeName: n,
  dataContext: r,
  getNodeDescriptor: o,
  expressionEvaluator: s
}) => {
  const a = N(h(e, i.DATA_SOURCE));
  if (!a)
    throw Error(`<List> is missing "${i.DATA_SOURCE}" parameter`);
  const l = h(r, a);
  if (Xe(l) || !dr(l) || Xe(t))
    return !1;
  const c = N(h(e, i.CONDITIONAL_RENDERING_EXPRESSION));
  return (c ? s.evaluateCondition(c, r) : !0) ? !!Tr(l, (u, T) => {
    const O = mn(r, u, T);
    return de({
      parentNodeName: n,
      nodes: t,
      dataContext: O,
      getNodeDescriptor: o,
      expressionEvaluator: s
    });
  }) : !1;
}, yi = (e) => {
  const { attributes: t, children: n, parentNodeName: r, dataContext: o, hostAppConfig: s, getNodeDescriptor: a, expressionEvaluator: l } = e;
  if (!n || !yn(e))
    return null;
  let c = !1;
  try {
    c = Oe(t, zt.SEPARATE_LIST_ITEMS);
  } catch (L) {
    throw Error(`Unable to render <List>. ${L.message}`);
  }
  const I = N(h(t, i.DATA_SOURCE)), T = h(o, I).reduce((L, S, y) => {
    const p = mn(o, S, y);
    if (!de({
      parentNodeName: r,
      nodes: n,
      dataContext: p,
      getNodeDescriptor: a,
      expressionEvaluator: l
    }))
      return L;
    const m = ge({
      parentNodeName: r,
      nodes: n,
      dataContext: p,
      hostAppConfig: s,
      getNodeDescriptor: a,
      expressionEvaluator: l
    });
    return L.push(/* @__PURE__ */ d(Le, { children: m }, y)), L;
  }, []);
  let O = T;
  if (c) {
    const L = bi(s, a);
    O = T.reduce((S, y, p) => (p && p < T.length && S.push(/* @__PURE__ */ d(Le, { children: L }, `separator-${p}`)), S.push(y), S), []);
  }
  return /* @__PURE__ */ d(Le, { children: O });
};
function bi(e, t) {
  const n = t(A.DIVIDER), r = { $root: {}, $data: "" }, o = {
    interpolateString: () => "",
    evaluateCondition: () => !0
  };
  return n.render({
    attributes: {},
    dataContext: r,
    hostAppConfig: e,
    getNodeDescriptor: t,
    expressionEvaluator: o
  });
}
var le = /* @__PURE__ */ ((e) => (e[e.BOLD = 0] = "BOLD", e[e.ITALIC = 1] = "ITALIC", e[e.UNDERLINE = 2] = "UNDERLINE", e[e.STRIKE_THROUGH = 3] = "STRIKE_THROUGH", e[e.LINE_BREAK = 4] = "LINE_BREAK", e))(le || {});
const vi = {
  b: 0,
  i: 1,
  s: 3,
  u: 2,
  br: 4
  /* LINE_BREAK */
};
function bn(e) {
  const t = vi[e.toLowerCase()];
  if (t !== void 0)
    return t;
  throw Error(`Unexpected text block child "${e}"`);
}
function vn(e, t, n) {
  return e.length ? e.reduce((r, o) => {
    if (Tt(o)) {
      const s = n.interpolateString(o.text, t);
      return r + N(s);
    } else {
      if (xe(o))
        return bn(o.name) === le.LINE_BREAK ? r : r + N(vn(o.children, t, n));
      throw Error(`Unexpected text block child "${o.type}"`);
    }
  }, "") : "";
}
function Gn(e, t, n) {
  return e.length ? e.map((o, s) => {
    if (Tt(o)) {
      const a = n.interpolateString(o.text, t);
      return /* @__PURE__ */ d(Le, { children: a }, s);
    } else if (xe(o)) {
      const a = bn(o.name);
      let l;
      switch (a !== le.LINE_BREAK && (l = Gn(o.children, t, n)), a) {
        case le.BOLD:
          return /* @__PURE__ */ d("b", { children: l }, s);
        case le.ITALIC:
          return /* @__PURE__ */ d("i", { children: l }, s);
        case le.LINE_BREAK:
          return /* @__PURE__ */ d("br", {}, s);
        case le.STRIKE_THROUGH:
          return /* @__PURE__ */ d("s", { children: l }, s);
        case le.UNDERLINE:
          return /* @__PURE__ */ d("u", { children: l }, s);
        default:
          return null;
      }
    } else
      throw Error(`Unexpected text block child "${o.type}"`);
  }).filter((o) => !!o) : null;
}
var Ne = /* @__PURE__ */ ((e) => (e.MAX_LINES = "maxLines", e.LINE_HEIGHT = "lineHeight", e))(Ne || {}), G = /* @__PURE__ */ ((e) => (e.ALIGNMENT = "alignment", e.BACKGROUND = "background", e.COLOR = "color", e.FONT_SIZE = "fontSize", e.FONT_WEIGHT = "fontWeight", e.WRAP_MODE = "wrap", e))(G || {});
const lt = new V({
  [G.ALIGNMENT]: { style: Z.LEFT, styleType: E.ALIGNMENT },
  [G.BACKGROUND]: { style: R.TRANSPARENT, styleType: E.COLOR },
  [G.COLOR]: { style: x.DEFAULT_TEXT, styleType: E.COLOR },
  [G.FONT_SIZE]: { style: J.DEFAULT, styleType: E.FONT_SIZE },
  [G.FONT_WEIGHT]: { style: Q.REGULAR, styleType: E.FONT_WEIGHT },
  [G.WRAP_MODE]: { style: ke.NORMAL, styleType: E.TEXT_WRAPPING }
}), Mn = [
  i.ARIA_DESCRIPTION,
  i.CLASS_NAME,
  i.ELEMENT_ID,
  i.TEXT_DIRECTION,
  i.TEST_ID,
  i.CONDITIONAL_RENDERING_EXPRESSION
], Gi = [Ne.MAX_LINES], Pn = lt.styleAttributeNames, Mi = [...Mn, ...Gi, ...Pn];
function Un(e) {
  const { attributes: t, children: n, dataContext: r, expressionEvaluator: o } = e, s = f(t, i.CONDITIONAL_RENDERING_EXPRESSION);
  return (s ? o.evaluateCondition(s, r) : !0) ? !!vn(n || [], r, o) : !1;
}
function Pi(e) {
  const { attributes: t, children: n, dataContext: r, hostAppConfig: o, expressionEvaluator: s } = e;
  if (!Un(e))
    return null;
  const a = ce(t, Mn), l = ie(A.TEXT, a, o), c = oe(Mi, l, lt.styleValues), I = se(c, lt.styleTypes, o), u = { ...c, ...I }, T = Ui(u), O = T[i.ARIA_DESCRIPTION], L = T[i.TEST_ID], S = q({ "aria-description": O }), y = q({ "data-testid": L }), p = T[Ne.MAX_LINES], m = /* @__PURE__ */ d(
    xi,
    {
      ...S,
      ...y,
      id: T[i.ELEMENT_ID],
      className: T[i.CLASS_NAME],
      dir: T[i.TEXT_DIRECTION] || "auto",
      $alignment: T[G.ALIGNMENT],
      $background: T[G.BACKGROUND],
      $color: T[G.COLOR],
      $fontSize: T[G.FONT_SIZE],
      $fontWeight: T[G.FONT_WEIGHT],
      $lineHeight: T[Ne.LINE_HEIGHT],
      $wrap: T[G.WRAP_MODE],
      children: Gn(n || [], r, s)
    }
  );
  return /* @__PURE__ */ d(Vt, { clamp: p, useNativeClamp: !0, children: m });
}
function Ui(e) {
  const t = Zt(e, Ne.MAX_LINES, mt);
  if (t <= 0)
    throw Error(`Unexpected maxLines attribute value. Expected a positive number, got "${t}"`);
  const n = F(e, Pn), r = F(e, [
    i.ARIA_DESCRIPTION,
    i.CLASS_NAME,
    i.ELEMENT_ID,
    i.TEST_ID
  ]), [o, s] = me(
    n[G.FONT_SIZE]
  );
  return {
    ...r,
    [i.TEXT_DIRECTION]: ze(e, i.TEXT_DIRECTION),
    ...n,
    [G.ALIGNMENT]: jt(e, G.ALIGNMENT),
    [Ne.MAX_LINES]: Math.min(t, mt),
    [G.FONT_SIZE]: o,
    [Ne.LINE_HEIGHT]: s,
    [G.WRAP_MODE]: f(e, G.WRAP_MODE)
  };
}
const xi = D(g)`
  background: ${(e) => e.$background || "inherit"};
  color: ${(e) => e.$color};
  font-size: ${(e) => e.$fontSize};
  font-weight: ${(e) => e.$fontWeight};
  line-height: ${(e) => e.$lineHeight || "normal"};
  text-align: ${(e) => e.$alignment || "inherit"};
  word-wrap: ${(e) => e.$wrap || "normal"};
`, Bt = () => null, wt = {
  [A.BLOCK]: { canRender: tn, nodeType: U.CONTAINER, render: to },
  [A.CARD]: { canRender: rn, nodeType: U.CONTAINER, render: lo },
  [A.DIVIDER]: { canRender: an, nodeType: U.DECORATIVE_NODE, render: Ro },
  [A.DRAWER]: { canRender: ln, nodeType: U.CONTAINER, render: mo },
  [A.DRAWER_FIXED_PART]: {
    canRender: En,
    nodeType: U.CONTAINER,
    render: Bt
  },
  [A.DRAWER_EXPANDABLE_PART]: {
    canRender: _o,
    nodeType: U.CONTAINER,
    render: Bt
  },
  [A.IMAGE]: { canRender: un, nodeType: U.DATA_VALUE, render: Vo },
  [A.LINK]: { canRender: gn, nodeType: U.DATA_VALUE, render: gi },
  [A.LIST]: { canRender: yn, nodeType: U.ITERATOR, render: yi },
  [A.SECTION]: { canRender: Nn, nodeType: U.CONTAINER, render: si },
  [A.STRING_VALUE]: {
    canRender: hn,
    nodeType: U.DATA_VALUE,
    render: Di
  },
  [A.TEXT]: { canRender: Un, nodeType: U.DATA_VALUE, render: Pi }
}, Qe = (e) => {
  const t = N(e);
  if (!wt[t])
    throw Error(`Unknown component "${e}"`);
  return wt[t];
};
function Bi(e) {
  return Ar(e, {
    preserveComments: !1,
    preserveXmlDeclaration: !0
  });
}
function wi(e) {
  const [t, n] = Ue(), r = $e(null);
  Ht(() => {
    r.current && !t && n(r.current);
  }, [t]);
  const o = t ? /* @__PURE__ */ d(_r, { target: t.shadowRoot, children: e.children }) : null;
  return /* @__PURE__ */ d(Sr.div, { ref: r, children: o });
}
function Ft({ template: e, data: t, hostConfig: n, options: r }, o) {
  const s = N(e);
  if (!s)
    throw Error("Invalid or missing template");
  const l = Bi(s).root, c = Rr(t), I = Object.freeze({
    ...dt(c) ? c : {},
    $data: c,
    $root: c
  }), u = Qe(l.name), T = yr();
  if (!u.canRender({
    attributes: l.attributes,
    children: l.children,
    dataContext: I,
    getNodeDescriptor: Qe,
    expressionEvaluator: T
  }))
    return null;
  const L = u.render({
    attributes: l.attributes,
    children: l.children,
    dataContext: I,
    hostAppConfig: n,
    getNodeDescriptor: Qe,
    expressionEvaluator: T,
    options: r
  });
  return /* @__PURE__ */ d("div", { ref: o, children: L });
}
const ts = sr(
  (e, t) => {
    var n;
    return (n = e.options) != null && n.useShadowDOM ? /* @__PURE__ */ d(wi, { children: Ft(e, t) }) : Ft(e, t);
  }
);
export {
  ts as ReactCardRenderer
};
//# sourceMappingURL=card-renderer.js.map
